import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import '../src/css/main.css'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { pageview } from '@/lib/ga'

axios.defaults.baseURL = 'https://backend.nexgridco.com'
axios.interceptors.request.use(
  config => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && user.token) {
      config.headers.Authorization = 'Bearer ' + user.token
    }
    return config
  },
  error => Promise.reject(error)
)

const darkModePreference = localStorage.getItem('darkMode') === 'true'
if (darkModePreference) {
  document.documentElement.classList.add('dark')
}

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)

router.isReady().then(() => {
  pageview(location.pathname + location.search)
})

app.mount('#app')
